const fadeIn = document.querySelector('.fadeIn');
const iconBanner = document.querySelector('.iconBanner');
const iconBlocks = document.querySelectorAll('.iconBlock');
const masonryBanner = document.querySelector('.masonryBanner');
const masonryBlocks = document.querySelectorAll('.masonryBlock');
const newsBanner = document.querySelector('.newsBanner');
const newsBlocks = document.querySelectorAll('.newsBlock');
const exploreBanner = document.querySelector('.exploreBanner');
const exploreBlocks = document.querySelectorAll('.exploreBlock');

// in viewport function
const isInViewport = function (elem) {
	let bounding = elem.getBoundingClientRect();
	return (
		bounding.top <= (window.innerHeight || document.documentElement.clientHeight) &&
		bounding.left <= (window.innerWidth || document.documentElement.clientWidth) &&
		bounding.bottom >= 0 &&
		bounding.right >= 0
	);
};

// check if element is in viewport, add class
function elementInViewport(element, className) {
	if (element) {
		if (isInViewport(element)) {
			element.classList.add(className);
		}
	}
}

//check if elements are in viewport, add class
function forEachElementInViewport(container, elements, className) {
	// if hereBlock in viewport
	if (container) {
		if (isInViewport(container)) {
			for (let i = 0; i < elements.length; i++) {
				(function (i) {
					setTimeout( () => {
						elements[i].classList.add(className);
					}, 300 * (i + 1));
				})(i);
			}
		}
	}
}

function runAnimations() {
	elementInViewport(fadeIn, 'fade-in');
	forEachElementInViewport(iconBanner, iconBlocks, 'fade-in');
	forEachElementInViewport(masonryBanner, masonryBlocks, 'fade-in');
	forEachElementInViewport(newsBanner, newsBlocks, 'fade-in');
	forEachElementInViewport(exploreBanner, exploreBlocks, 'fade-in');
}

window.addEventListener('scroll', () => {
	runAnimations();
})

window.addEventListener('load', () => {
	runAnimations();
})